import React from 'react'
import Header from './Header'
import Footer from './Footer'
import {config} from '../config';

function PrivacyPolicy(){
  return(
    <>
    <Header />
    <div className="term-condition">
      <div className="container" >
        <div className="row">
          <div className="col-md-12">
            <div className="title">
              <h3>Privacy Policy</h3>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
               <h5 className="custom-heading return">Privacy Policy </h5>
                <div className="row return-policy">
                     <div className="col-md-1"></div>
                     <div className="col-md-11">
                     <div>
<p>
 {config.RestaurantName} is committed to keeping your Personal Information
 private and secure. This Privacy Policy describes what Personal Information
 the {config.RestaurantName} platform and {config.RestaurantName}orderonline.com (the
 “website,” “us,” “our” and “we”) collects and how we use it. {config.RestaurantName}, and the {config.RestaurantName} services are
 provided by Dining Software Group, Inc.
</p>
<p>
 &nbsp;“Personal Information” as used in this policy means information that
 relates to and identifies you, and as defined by any applicable privacy
 laws. If you have any questions or comments regarding this Privacy Policy,
 please contact us at support@diningtek.com
</p>
<p>
 <strong>Changes to Our Privacy Policy</strong>
</p>
<p>
 We may make changes to the Privacy Policy from time to time. We will notify
 you of any material changes by posting a notice on the website. Please
 review any changes to our Privacy Policy carefully to ensure you understand
 our practices and procedures.
</p>
<p>
 <strong>Information We Collect and Receive</strong>
</p>
<p>
 We collect Personal Information about you when you visit our website or any
 restaurant websites that we operate, when you place an order with us, and
 when you communicate with us through email, telephone, website form, or
 otherwise. The Personal Information we collect includes:
</p>
<ul>
 <li>
   Order information, including name, delivery and/or billing address, phone
   number, payment information, order contents, restaurant, delivery time,
   and any other information provided by you concerning you order.
 </li>
 <li>
   Account information, including name, password, email address, and
   residential address.
 </li>
 <li>
   Name, address, email, other contact information and any other information
   you provide when you contact us regarding our company or our services.
 </li>
 <li>
   General website statistics and usage information including your IP
   address, page views, type of web browser, GPS, and operating system,
   duration of your visits, and information about the content and pages you
   view and the features you access on the website.
 </li>
 <li>
   Any other information you send to use through communications including
   email, telephone, website form, or otherwise.
 </li>
</ul>
<p>
 Cookies. This website uses cookies to collection information about how you
 use the website. A cookie is a small file containing a string of characters
 that is sent to your computer when you visit a website. When you visit the
 website again, the cookie allows that website to recognize your browser.
 Cookies may store unique identifiers, user preferences, and other
 information. You can set your browser to refuse all cookies or to indicate
 when a cookie is being sent, however, some website features or services may
 not function properly without cookies.
</p>
<p>
 Do Not Track Signals.<strong>&nbsp;&nbsp;</strong>This website does not
 respond to Do Not Track (“DNT”) signals. Third-party applications and
 plugins, such as social media integration, may treat DNT signals
 differently.
</p>
<p>
 No Information from Children Under Age 18. This website is not directed to
 children under the age of 18. If we learn that we have collected Personal
 Information from a child under the age of 18, we will promptly delete that
 information. If you believe we have collected Personal Information from
 someone under age 18, please email us at support@diningtek.com.&nbsp;
</p>
<p>
 <strong>How We Use Your Personal Information</strong>
</p>
<p>
 {config.RestaurantName} primarily provides online ordering platforms, mobile
 applications, and marketing services for the restaurant and hospitality
 industry. Most of the Personal Information we collect is for processing
 orders that customers place with our restaurant clients.
</p>
<ul>
 <li>
   <strong>Order Information</strong>: We use order information to process
   your orders, donations, and payments, and to communicate information to
   our restaurant clients so that they can fulfill your orders.
 </li>
 <li>
   <strong>Contact Information</strong>: We use the contact information we
   collect about you for our communications regarding our company and
   services.
 </li>
 <li>
   <strong>Other</strong>: For all website visitors, we use your Personal
   Information to improve and maintain our website and services.
 </li>
</ul>
<p>
 <strong>When We Disclose Information</strong>
</p>
<p>
 Disclosure of Order Information. We process food and services orders on
 behalf of our restaurant and hospitality clients and will disclose
 information related to those orders to such clients so that they may
 properly fulfill such orders. If you contact {config.RestaurantName} regarding
 your order or any issues with your order, we may also disclose some or all
 of those communications to the business about which you are calling so that
 we may troubleshoot and/or resolve your issue.&nbsp;
 <em>
   Please review each business’s privacy notice for any information
   concerning their use of your Personal Information before placing an order.
   This Privacy Policy does not apply to the use of your Personal Information
   by any of our restaurant clients after we have informed them of your
   order.
 </em>
</p>
<p>
 Disclosure to Third Party Service Providers.&nbsp; We engage third-party
 service providers to assist in providing data storage, website hosting,
 analytics, and other services. Personal Information is hosted on their
 servers and services on our behalf and is kept confidential and limited to
 {config.RestaurantName}’s use. {config.RestaurantName} uses industry standard
 third-party payment processors to process orders, and discloses your payment
 information solely for the purpose of processing authorized payments.
</p>
<p>
 Disclosures for Legal Requirements. We may disclose your Personal
 Information to respond to legal requirements, to protect or enforce our
 rights and policies, to protect or enforce the rights of a third party, to
 prevent harm to a person or as required or permitted by law, including,
 without limitation, to comply with a subpoena or court order.
</p>
<p>
 Disclosure of Non-Personal Information. We may disclose anonymized or
 de-identified information to any party including potential business
 partners, advertisers, investors, users, and other third parties.
</p>
<p>
 Disclosure to Corporate Affiliates and Successors. {config.RestaurantName} may
 disclose Personal Information and other data to its parent, subsidiaries or
 other affiliates, if any.&nbsp; If {config.RestaurantName} is part of a merger,
 acquisition, reorganization, sale of some or all of its assets, or similar
 transaction, or takes steps in contemplation of such transactions (e.g., due
 diligence), Personal Information and other data may be shared or transferred
 with a new or prospective owner, subject to standard confidentiality
 agreements.&nbsp;&nbsp;
</p>
<p>
 Disclosure with Your Consent. In addition to the sharing described elsewhere
 in this Privacy Policy, we may share Personal Information with third parties
 if we obtain your consent to do so.
</p>
<p>
 Disclosure to Analytics and Advertising Partners. We use analytics cookies
 and services including, but not limited to, Google Analytics, to understand
 our website visits and use. For more information about how Google Analytics
 uses your information, please see
 https://www.google.com/policies/privacy/partners/.
</p>
<p>
 <strong>California Shine the Light Rights</strong>
</p>
<p>
 California’s “Shine the Light” law permits California residents to request
 certain information regarding our disclosure of Personal Information to
 third parties for their direct marketing purposes. To obtain this
 information, please send an email message to support@diningtek.com with
 “Shine the Light Request” on the subject line and in the body of your
 message. We will provide the requested information to you at your e-mail
 address in response. Please be aware that not all information is covered by
 the “Shine the Light” requirements and only information on covered sharing
 (if any) will be included in our response.
</p>
<p>
 <strong>Storage and Retention</strong>
</p>
<p>
 Your Personal Information is stored by {config.RestaurantName} on our servers
 and on the servers of the cloud-based data storage providers that we engage.
 DiningTek retains Personal Information for the duration of our business
 relationship with you, for the purposes indicated in this Privacy Policy,
 and for such other periods as required by law, which may be indefinitely.
</p>
<p>
 <strong>Data Security</strong>
</p>
<p>
 {config.RestaurantName} and DiningTek take the privacy of your information
 seriously. We use industry standard physical, technical and administrative
 security measures and safeguards to protect the confidentiality and security
 of Personal Information. However, since the Internet is not a 100% secure
 environment, we cannot guarantee the security of any information you
 transmit to us. Further, it is your responsibility to protect the security
 of your account and login information. Please note that content you store or
 transmit through the website, or e-mails and other communications you send
 to us, may not be encrypted.&nbsp;
</p>
<p>
 <strong>Third Party Websites</strong>
</p>
<p>
 You may be able to access third-party websites directly from this website.
 This Privacy Policy does not apply when you access third-party websites. We
 cannot control how third parties may use any information you disclose to
 them, so you should carefully review the privacy policy of any third-party
 website you visit before using it or disclosing your information to its
 provider.
</p>
<p>
 <strong>Questions and How to Contact Us</strong>
</p>
<p>
 If you have any questions or concerns regarding our Privacy Policy or
 practices, including to exercise any rights you may have, or otherwise need
 to contact us regarding your Personal Information, please contact us by
 emailing support@diningtek.com.&nbsp;
</p>
<p>&nbsp;</p>
</div>
                      </div>
                </div>
          </div>
        </div>
        </div>
      </div>
    <Footer />
    </>
  )
}

export default PrivacyPolicy;
